import { LOCALES, DEFAULT_LANG, langPrefix } from "@/i18n/locales";
import { HENPROFIT_GEN } from "./henprofit_gen";

export function henprofitSlug(lang) {
  return (HENPROFIT_GEN[lang] || HENPROFIT_GEN[DEFAULT_LANG] || {}).slug;
}
export function henprofitData(lang) {
  return HENPROFIT_GEN[lang] || HENPROFIT_GEN[DEFAULT_LANG] || {};
}
export function henprofitPath(lang) {
  return `${langPrefix(lang)}/${henprofitSlug(lang)}`;
}
export function buildHenprofitAlternates(origin) {
  const o = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  const alts = LOCALES.filter((l) => henprofitSlug(l.code)).map((l) => ({ hreflang: l.hreflang, href: `${o}${henprofitPath(l.code)}` }));
  if (henprofitSlug(DEFAULT_LANG)) alts.push({ hreflang: "x-default", href: `${o}${henprofitPath(DEFAULT_LANG)}` });
  return alts;
}
export const HENPROFIT_SLUGS = Object.fromEntries(LOCALES.map((l) => [l.code, henprofitSlug(l.code)]).filter(([, s]) => s));
